export const stepsData = [
    {
    number: 1,
    title: "Réservez votre 1er rendez-vous en visioconférence",
    description: "Profitez d'une expertise personnalisée pour avancer en toute sérénité.",
    details: [
      "Une expertise à vos côtés pour avancer en toute sérénité",
      "Accompagnement 100% en visioconférence",
      "Confidentialité garantie de vos données et échanges"
    ]
  },
  {
    number: 2,
    title: "Signez contrat & CGV",
    description: "Première étape simple et rapide pour démarrer votre accompagnement fiscal en toute sérénité.",
    details: [
      "Signature électronique des documents",
      "Lecture des conditions générales de vente",
      "Validation de votre engagement"
    ]
  },
  {
    number: 3,
    title: "Réglez 340€ TTC",
    description: "Un tarif simple et transparent pour un accompagnement complet sur l'année.",
    details: [
      "340€ TTC par an",
      "Option au succès : En cas de déclarations rectificatives nos honoraires porteront sur les économies que vous allez réaliser !",
      "Exemple : Economie fiscale identifiée : 1 200€ -> Honoraires : 340€ (soit 20%) -> Gain Net + 1 060€"
    ]
  }

];